import React, { useMemo } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PageMain from "pages/main";
import { PageLoginOld } from "pages/User/loginOld";
import PageLogin from "pages/User/login";
import PageHomework from "pages/homework";
import BaiduTrack from "./components/BaiduTrack";
import PageHomeworkList from "pages/HomeworkList";
import PageExamList from "pages/Exam/ExamList";
import PageExamMain from "pages/Exam/ExamMain";
import PageCourseDetail from "pages/CourseDetail";

import zhCN from "antd/es/locale/zh_CN";
import { ConfigProvider } from "antd";
import PageBridge, { ClientType } from "pages/Bridge";
import PageExamTime from "./pages/Exam/ExamTime";
import PageNoticeList from "pages/Notice/NoticeList";
import PageChangePwd from "./pages/User/changePwd";
import CourseList from "./pages/CourseList";
import PageExperimentMain from "./pages/PageExperimentMain";
import ExperimentDetail from "./pages/PageExperimentMain/components/ExperimentDetail";
import CourseChapters from "./pages/CourseChapters";
import Evaluate from "./pages/Evaluate";
import EvaluateList from "./pages/Evaluate/List";
import CourseScore from "./pages/CourseScore";
import Chat from "./pages/Chat";
import ChatDetail from "./pages/Chat/ChatDetail";
import Feedback from "./pages/Feedback";
import Boundary from "./components/Boundary";
import { LayoutRoute } from "./components/LayoutRoute";
import RootLayout from "./components/Layouts/RootLayout";
import LoginConsole from "./pages/User/loginConsole";
import AskTeacher from "./pages/AskTeacher";
import { TopLayout } from "./components/Layouts/TopLayout";
import { SubLayout } from "./components/Layouts/SubLayout";
import { JPush } from "./components/JPush";
import SystemMsgDetail from "./pages/Notice/SystemMsgDetail";
import { SystemMsgList } from "./pages/Notice/SystemMsgList";
import { Settings } from "./pages/Settings";
import { NavigateListener } from "./components/NavigateListener";

export const ContainerContext = React.createContext({ isInside: false });

const App = () => {
    const isInside = useMemo(() => {
        return localStorage.getItem("clientType") === ClientType.Dufe;
    }, []);

    return (
        <ConfigProvider locale={zhCN}>
            <Boundary>
                <ContainerContext.Provider value={{ isInside }}>
                    <Router>
                        <BaiduTrack />
                        <NavigateListener />

                        <Switch>
                            <Route exact path="/login" component={PageLogin} />
                            <Route
                                exact
                                path="/login/old"
                                component={PageLoginOld}
                            />
                            <Route
                                exact
                                path="/login/console"
                                component={LoginConsole}
                            />

                            <LayoutRoute path="/changepwd" layout={SubLayout}>
                                <PageChangePwd />
                            </LayoutRoute>

                            <LayoutRoute
                                exact
                                path="/homework/"
                                component={PageHomeworkList}
                                layout={TopLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/homework/:id"
                                component={PageHomework}
                                layout={RootLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/exam/"
                                component={PageExamList}
                                layout={TopLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/exam/time"
                                component={PageExamTime}
                                layout={SubLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/exam/:id"
                                component={PageExamMain}
                                layout={RootLayout}
                            />
                            <Route
                                exact
                                path="/evaluate/:evaluationId/:multiEvaluationFlag"
                                component={Evaluate}
                            />
                            <LayoutRoute
                                exact
                                path="/evaluate/list"
                                component={EvaluateList}
                                layout={RootLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/notice"
                                component={PageNoticeList}
                                layout={TopLayout}
                            />

                            <LayoutRoute
                                exact
                                path="/notice/system"
                                component={SystemMsgList}
                                layout={TopLayout}
                            />

                            <LayoutRoute
                                exact
                                path="/notice/system/:id"
                                component={SystemMsgDetail}
                                layout={SubLayout}
                            />

                            <LayoutRoute
                                exact
                                path="/course/list"
                                component={CourseList}
                                layout={SubLayout}
                            />

                            <LayoutRoute
                                exact
                                path="/bridge"
                                component={PageBridge}
                                layout={RootLayout}
                            />
                            {/*课程管理系列页面, 注意, 内含子路由*/}
                            <Route
                                path="/course/detail/:courseNo/:courseSeq/:weekTimeId"
                                component={PageCourseDetail}
                            />
                            <Route
                                path="/course/chapters/:courseNo/:courseSeq/:weekTimeId?"
                                component={CourseChapters}
                            />
                            <Route
                                path="/course/score/:tab/:courseNo/:courseSeq/:weekTimeId?"
                                component={CourseScore}
                            />
                            <LayoutRoute
                                exact
                                path="/experiment"
                                component={PageExperimentMain}
                                layout={TopLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/experiment/detail/:experimentId"
                                component={ExperimentDetail}
                                layout={SubLayout}
                            />
                            {/*聊天*/}
                            <LayoutRoute
                                exact
                                path="/chat"
                                component={Chat}
                                layout={TopLayout}
                            />
                            <LayoutRoute
                                exact
                                path="/chat/detail/:sessionUid"
                                component={ChatDetail}
                                layout={SubLayout}
                            />
                            {/*用户反馈*/}
                            <LayoutRoute
                                exact
                                path="/feedback"
                                component={Feedback}
                                layout={SubLayout}
                            />

                            {/*系统设置*/}
                            <LayoutRoute
                                path="/settings"
                                component={Settings}
                                layout={SubLayout}
                            />

                            {/*答疑*/}
                            <Route path="/askTeacher" component={AskTeacher} />

                            <LayoutRoute
                                path="/"
                                component={PageMain}
                                layout={TopLayout}
                            />
                        </Switch>
                        {/* 接收推送消息并处理跳转 */}
                        <JPush />
                    </Router>
                </ContainerContext.Provider>
            </Boundary>
        </ConfigProvider>
    );
};

export default App;
